import { AxiosResponse } from 'axios'

import { ApiExceptionJSON } from 'api/domain/app'
import { ApiErrorBase } from 'api/core/ApiErrorBase'

export class ApiException extends ApiErrorBase {
  constructor({ errors }: ApiExceptionJSON, { status }: AxiosResponse) {
    const error = errors[0]

    if (error) {
      super({
        message: error.detail,
        type: error.status,
        statusCode: status,
      })
    } else {
      super({
        message: 'Unhandled API error',
        statusCode: status,
      })
    }
  }
}
